export const Calendar = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={15} fill="none">
        <path
            fill="#A5AAAF"
            d="M14 2h-2V.667h-1.333v4H12V3.333h2v10H2v-10h1.333V2H2C1.264 2 .667 2.596.667 3.333v10c0 .736.597 1.333 1.333 1.333h12c.736 0 1.333-.597 1.333-1.333v-10C15.333 2.596 14.736 2 14 2Z"
        />
        <path
            fill="#A5AAAF"
            d="M5.333 3.333H10V2H5.333V.667H4v4h1.333V3.333ZM3.333 6H6v2.666H3.333V6ZM9.333 6H6.667v2.666h2.666V6ZM10 6h2.667v2.666H10V6ZM6 9.333H3.333V12H6V9.333ZM6.667 9.333h2.666V12H6.667V9.333Z"
        />
    </svg>
);
